export const PaymentsMethods: any = {
    yookassa: "ЮКасса",
    other:"Другое"
};
